// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { Config } from "../config";
import {
    JournalEntry,
    JournalCategory,
    JournalEntrySearchRequest,
    JournalEntryTemplate,
    AddJournalEntriesRequest,
} from "./types/journalEntryTypes";

const apiManagementRootUrl: string | undefined = Config.REACT_APP_CCL_API_MANAGEMENT_URL;

// Define a service using a base URL and expected endpoints
export const cclTokenedJournalEntryApi = createApi({
    reducerPath: "cclTokenedJournalEntryApi",
    tagTypes: ["JournalCategories", "JournalTemplates"],
    baseQuery: fetchBaseQuery({
        baseUrl: apiManagementRootUrl,
        prepareHeaders: (headers, { getState }) => {
            //we should probably change this.
            const token = localStorage.getItem("token") as string;
            headers.set("authorization", `Bearer ${token}`);
            return headers;
        },
    }),
    endpoints: (builder) => ({
        saveJournalEntry: builder.mutation<JournalEntry[], AddJournalEntriesRequest>({
            query: (args) => ({
                url: "ccl-access2-data/v1.0/JournalEntries",
                method: "POST",
                body: args,
            }),
        }),
        getJournalCategories: builder.query<JournalCategory[], void>({
            query: (userid) => "ccl-access2-data/v1.0/JournalEntries/categories",
            providesTags: ["JournalCategories"],
        }),
        searchJournalEntries: builder.mutation<JournalEntry[], JournalEntrySearchRequest>({
            query: (args) => ({
                url: "ccl-access2-data/v1.0/JournalEntries/search",
                method: "POST",
                body: args,
            }),
        }),
        getJournalTemplates: builder.query<JournalEntryTemplate[], number>({
            query: (categoryId) => `ccl-access2-data/v1.0/JournalTemplates/${categoryId}`,
            providesTags: (_, __, categoryId) => [{ type: "JournalCategories", id: categoryId }],
        }),
        deleteJournalEntry: builder.mutation<void, number>({
            query: (journalEntryId) => ({
                url: `ccl-access2-data/v1.0/JournalEntries/delete/${journalEntryId}`,
                method: "DELETE",
            }),
        })
    }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
    useSaveJournalEntryMutation,
    useSearchJournalEntriesMutation,
    useGetJournalTemplatesQuery,
    useDeleteJournalEntryMutation,
} = cclTokenedJournalEntryApi;
